import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { villageConfig } from '../config/index';
import { VillageService } from '../../../../shared/services/villageService';

/**
 * VillageDetail - URL-based detail page for Villages
 * Handles view, edit, and add modes with ID from URL params
 */
export default function VillageDetail() {
  return (
    <CRUDDetailPage
      config={villageConfig}
      service={VillageService}
    />
  );
}
